// extracted by mini-css-extract-plugin
module.exports = {"loadingBanner":"_e748d35"};